import { definePreset } from '@primeng/themes'
import Material from '@primeng/themes/material'

const white = '#ffffff'
const transparent = '#00000000'
const textColorPrimary = '#504e55'
const red = '#ff0000'
const bigShadow =
    '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)'
const buttonPrimary = '#376fd0'
export const PrimeNGTheme = definePreset(Material, {
  components: {
    tree: {
      root: {
        background: 'white'
      },
      node: {
        padding: '0.35rem 0.5rem',
        hoverBackground: '#e9f4ff' // very light blue
      }
    },
    checkbox: {
      root: {
        width: '18px',
        height: '18px',
        background: 'white',
        checkedBackground: buttonPrimary,
        checkedHoverBackground: buttonPrimary,
        checkedBorderColor: buttonPrimary,
        checkedHoverBorderColor: buttonPrimary,
        checkedFocusBorderColor: buttonPrimary
      }
    },

    dialog: {
      root: {
        background: white,
        borderColor: '#c8c8c8',
        borderRadius: '3px',
        shadow: '0 0 6px 0 rgba(0, 0, 0, 0.16)',
        color: textColorPrimary
      }
    },
    confirmpopup: {
      root: {
        background: white,
        color: textColorPrimary,
        borderRadius: '3px',
        borderColor: transparent,
        shadow: bigShadow
      },
      content: {
        padding: '1rem'
      },
      footer: {
        padding: '0.5rem 1rem'
      },
      css: 'z-index:1002'
    },
    popover: {
      root: {
        background: white,
        shadow: bigShadow
      },
      content: {
        padding: '16px'
      },
      css: 'font-size:16px'
    },
    toast: {
      root: {
        width: '22rem'
      },
      success: {
        background: '#cce7cd',
        color: textColorPrimary
      },
      info: {
        background: '#d1ecf1',
        color: textColorPrimary
      },
      warn: {
        background: '#eedeae',
        color: textColorPrimary
      },
      error: {
        background: '#ffdddd',
        color: textColorPrimary
      },
      css: `
    .p-toast-message {
      padding: 0.75rem 1rem;
      display: flex;
      align-items: center;
      gap: 0.5rem;
      border: none;
      border-left: 5px solid transparent;
      border-radius: 2px;

    }

    .p-toast-message-success { border-left: 5px solid #408a46;  }
    .p-toast-message-info { border-left: 5px solid #17a2b8; }
    .p-toast-message-warn { border-left: 5px solid #d2a10f; }
    .p-toast-message-error { border-left: 5px solid #ff5c5c; }
    

   
  `
    },
    autocomplete: {
      dropdown: {
        width: '48px'
      }
      // css: `
      //   .p-autocomplete-dropdown {
      //     background-color: ${buttonPrimary}
      //   }
      //   .p-autocomplete-input {
      //   }
      // `
    }
  }
})
